import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "@/views/Login";
import LoginVerification from "@/views/LoginVerification";
import LoginSecond from "@/views/LoginSecond";

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        component: Login
    },
    {
        path: '/login-verification',
        component: LoginVerification
    },
    {
        path: '/login-second',
        component: LoginSecond
    },
]
const router = new VueRouter({
    routes,
    mode: 'history',
})

export default router
